import React from 'react'
import { useState, useEffect } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Baseurl } from '../../../Config/Baseurl'
import axios from 'axios'
import PhoneInput from 'react-phone-input-2'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import moment from 'moment'

export const AddStudents = () => {
  toast.configure()
  const [Phone, setPhone] = useState('')
  const [position, setPosition] = useState([])
  const [file, setFile] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [exams, setExams] = useState([])
  const [values, setValues] = useState({
    password: '',
    enrollment: '',
    year: '',
    course: '',
    institute: '',
    examTitle: '',
    recruitment: '',
    position: '',
    email: '',
    name: '',
    startDate: '',
    endDate: '',
  })

  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
  }

  //add excel file of students
  const addStudents = async () => {
    const formdata = new FormData()

    formdata.append('registerData', file)

    const config = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: formdata,
    }

    await fetch(Baseurl.nodeLocal + 'auth/studentRegistration', config)
      .then((response) => response.json())
      .then((json) => {
        toast.success(json.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
      .catch((err) => {
        toast.error(err, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
      })
  }

  // to get positions
  const getvalues = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'dropdown/fetchPositions')
      .then((res) => {
        setPosition(res.data.data)
      })
      .catch((error) => {})
  }
  useEffect(() => {
    getvalues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // to hide/show password
  const onMouseDown = () => {
    setShowPassword(!showPassword)
  }

  // to register single student/candidate
  const addStudent = async (e) => {
    e.preventDefault()
    await axios
      .post(Baseurl.nodeLocal + 'auth/manualStudentRegistration', {
        enrollment: values.enrollment,
        name: values.name,
        email: values.email,
        contact: Phone,
        password: values.password,
        course: values.course,
        institute: values.institute,
        academic_year: values.year,
        applied_for: values.position,
        ins_status: values.recruitment,
        exam_id: values.examTitle,
        start_date: values.startDate,
        end_date: values.endDate,
      })
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
      })
  }

  // to get already declared exams
  const getExam = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'exam/fetchAllExams')
      .then((res) => {
        setExams(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getExam()
  }, [])
  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="col-md-10 mt-4 d-flex justify-contetn-center align-items-center flex-column">
        {/* breadcrumbs */}
        <div className="d-flex justify-contetn-center">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/examdashboard" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/viewstudents" className="link text-primary">
                  Students List
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Add Students
              </li>
            </ol>
          </nav>
        </div>

        {/* add exacel file of studnets' details */}
        <div className="card w-75 p-4 d-flex justify-content-center">
          <h4 className="d-flex justify-content-center">Add Students</h4>
          <h6 className="m-b-20 p-b-5 b-b-default f-w-600 mt-5">
            Import Students File
          </h6>
          <div className="row p-2">
            <input
              className="col-md form-control"
              type="file"
              onChange={(e) => {
                setFile(e.target.files[0])
              }}
            />
            <div className="col-md d-flex justify-content-end">
              <button className="btn btn-primary " onClick={addStudents}>
                Submit
              </button>
            </div>
          </div>

          {/* to register single student */}
          <h6 className="m-b-20 p-b-5 b-b-default f-w-600 mt-5">Add Student</h6>
          <h6 className="m-b-20 p-b-5 f-w-600">Personal Details</h6>
          <form onSubmit={addStudent}>
            {' '}
            <div className="row p-2 mt-3">
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Email address
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="exampleFormControlInput1"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Contact
                </label>
                <PhoneInput
                  country={'in'}
                  value={Phone}
                  onChange={setPhone}
                  enableSearch
                  inputStyle={{ width: '100%' }}
                />
              </div>
            </div>{' '}
            <div className="row p-2">
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Position
                </label>
                <select
                  className="form-select"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  name="position"
                  value={values.position}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {position?.map((i, index) => {
                    return (
                      <option value={i.value} key={index}>
                        {i.name}
                      </option>
                    )
                  })}
                </select>
              </div>
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Recruitment
                </label>
                <select
                  className="form-select"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  name="recruitment"
                  value={values.recruitment}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="On Campus">On Campus</option>
                  <option value="Off Campus">Off Campus</option>
                </select>
              </div>
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Exam Title
                </label>
                <select
                  className="form-select"
                  id="floatingSelect"
                  aria-label="Floating label select example"
                  name="examTitle"
                  value={values.examTitle}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {exams?.map((i, index) => {
                    return (
                      <option value={i.exam_id} key={index}>
                        {i.exam_name}
                      </option>
                    )
                  })}
                </select>
              </div>
            </div>
            <div className="row p-2">
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Start Date
                </label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="startDate"
                  value={values.startDate}
                  onChange={handleChange}
                  min={moment(new Date()).format('YYYY-MM-DD')}
                  required
                />
              </div>
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  End Date
                </label>
                <input
                  type="datetime-local"
                  className="form-control"
                  name="endDate"
                  min={moment(new Date()).format('YYYY-MM-DD')}
                  value={values.endDate}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <h6 className="m-b-20 p-b-5 f-w-600">Academic Details</h6>
            <div className="row p-2">
              <div className="mb-3 col-md-6">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Institute
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  name="institute"
                  value={values.institute}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 col-md-6">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Course
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  name="course"
                  value={values.course}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Academic Year
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  name="year"
                  value={values.year}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Enrollment/RegisterId
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleFormControlInput1"
                  name="enrollment"
                  value={values.enrollment}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 col-md-4">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label"
                >
                  Password
                </label>
                <div className="input-group col-md text-secondary">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    id="exampleFormControlInput1"
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    required
                  />
                  <span
                    className="input-group-text"
                    id="inputGroup-sizing-default"
                    onMouseDown={onMouseDown}
                    onMouseUp={onMouseDown}
                  >
                    {showPassword ? (
                      <AiOutlineEyeInvisible />
                    ) : (
                      <AiOutlineEye />
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
